// extracted by mini-css-extract-plugin
export var bodyRow = "_co-d";
export var cardColumns = "_co-e";
export var ellipsesOverflow = "_co-2";
export var flatBottomCorners = "_co-3";
export var flatTopCorners = "_co-4";
export var headerActionsDropdown = "_co-f";
export var headerBottomRow = "_co-c";
export var headerTopRow = "_co-b";
export var orderDetailsWrapper = "_co-0";
export var orderInfoContainer = "_co-1";
export var productDetails = "_co-9";
export var productImage = "_co-5";
export var responsiveTable = "_co-8";
export var shipmentContainer = "_co-a";
export var tableBottomLeft = "_co-6";
export var tableBottomRight = "_co-7";
export var trackingLink = "_co-g";